export const matchesServicePath=(path,prefix)=>path===prefix||path.startsWith(prefix+'/');
export function serviceForPage(services,path,portal){
 return services.find(s=>s.pages.some(p=>matchesServicePath(path,p))||s.portals.some(p=>path==='/'+p)||portal&&s.portals.includes(portal));
}
export function flagEnabled(flags,services,key,ready=true){
 if(!key)return true;
 if(!ready)return false;
 const service=services.find(s=>s.key===key ||
  key.startsWith('tile.')&&s.tiles.includes(key.slice(5)) ||
  key.startsWith('nav.')&&s.pages.some(p=>matchesServicePath(key.slice(4),p)) ||
  key.startsWith('portal.')&&s.portals.includes(key.slice(7)));
 return (!service||flags[service.key]!==false)&&flags[key]!==false;
}
